export default {
      id: "checkbox-indeterminate-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#checkbox-indeterminate",
      toString: function () {
        return this.url;
      }
    }